module.exports = __webpack_public_path__ + "static/media/RawsonPro-MediumIt.9c65f164.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/RawsonPro/MediumIt/RawsonPro-MediumIt.ttf
// module id = 370
// module chunks = 17